// extracted by mini-css-extract-plugin
export default {"searchResult":"searchResult--2wEGI","title":"title--30QdS","url":"url--2T7xy","description":"description--3FWUv"};